import { BaseService } from 'core/services';
import ImportDetailRouteService from './ImportDetailRouteService';

class ImportDetailService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImportDetailRouteService());
    }

    async update(resource){
        const url = this.routeService.update(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async findItemGroup(resource){
        const url = this.routeService.findItemGroup(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async isRunning(resource){
        const url = this.routeService.isRunning(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async findGroupedByPatients(resource){
        const url = this.routeService.findGroupedByPatients(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async getByPatient(resource){
        const url = this.routeService.getByPatient(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async import(resource){
        const url = this.routeService.import(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async process(resource){
        const url = this.routeService.process(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async importAll(resource){
        const url = this.routeService.importAll(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async usePatient(resource){
        const url = this.routeService.usePatient(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async updateReviewed(resource){
        const url = this.routeService.updateReviewed(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    getPatientNavigation(importHeaderId, patientGroupId) {
		const url = this.routeService.getPatientNavigation({ importHeaderId, patientGroupId });
		return this.apiClient.get(url);
	}
}

export default ImportDetailService;
